if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const openedMediaId = this.openedBy.getAttribute('data-media-id');
        const activeMedia = this.querySelector(`[data-media-id="${openedMediaId}"]`);
        if (!activeMedia) return;

        const activeMediaColor = activeMedia.dataset.bpdMediaColor;
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          const isActive = element.dataset.mediaId === openedMediaId;
          const isDifferentColor =
            activeMediaColor && element.dataset.bpdMediaColor && element.dataset.bpdMediaColor !== activeMediaColor;

          element.hidden = Boolean(isDifferentColor);
          element.classList.toggle('active', isActive);
        });
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        const activeMediaWidth = activeMedia.getBoundingClientRect().width || activeMedia.width || 0;
        container.scrollLeft = (activeMediaWidth - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
